import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../../services/http.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  typeUser: any;
  isLoading: boolean | undefined;
  
  form: FormGroup = new FormGroup({});

  constructor(private formBuilder: FormBuilder, private router: Router, private httpService: HttpService, private route: ActivatedRoute) {
    this.typeUser = this.route.snapshot.paramMap.get('typeUser');
    if (this.typeUser != 'candidat' && this.typeUser != 'consultant' && this.typeUser != 'entreprise' && this.typeUser != 'admin') {
      this.router.navigate(['/not-found']);
    }
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmitForm() {
    const formValue = this.form.value;
    formValue['type_user'] = this.typeUser;
    
    this.isLoading = true;
    this.httpService.resetPassword(formValue).subscribe(
      (response: any) => {
        if (response.status == "success") {
          this.form.reset();
          this.isLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent!',
            text: 'Mot de passe réinitialisé. Consulter votre boite mail afin de créer un nouveau mot de passe.',
          })
        }
      },
      (error) => {
        this.isLoading = false;
        if (error.error.message && error.error.message == 'EMAIL_DOES_NOT_EXIST') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Cette adresse mail n\'existe pas.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }
}
